// Generated by Melange

import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__ManageProductModal from "../../components/organisms/Manage/ManageProductModal.js";
import * as Buhta_cabinet__ManageProducts from "../../components/organisms/Manage/ManageProducts.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ManageProductsPage(Props) {
  let org = Props.org;
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
    title: "Товары"
  });
  const match = React.useState(function () {
    return false;
  });
  const setModal = match[1];
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
        header: header,
        children: JsxRuntime.jsx(Buhta_cabinet__ManageProducts.make, {
          org: org,
          onNewProduct: (function (param) {
            Curry._1(setModal, (function (param) {
              return true;
            }));
          })
        })
      }),
      match[0] ? JsxRuntime.jsx(Buhta_cabinet__ManageProductModal.make, {
          onClose: (function (param) {
            Curry._1(setModal, (function (param) {
              return false;
            }));
          })
        }) : null
    ]
  });
}

const make = ManageProductsPage;

export {
  make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
